import _ from 'lodash';
import { connect } from 'react-redux';
import { get, update, add } from '../../modules/accounting/invoiceDocument';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	let invoiceDocument;
	let invoiceDocumentId;

	if (ownProps.invoiceDocument) {
		invoiceDocument = ownProps.invoiceDocument;
	} else {
		invoiceDocumentId = (ownProps.invoiceDocumentId)
			? ownProps.invoiceDocumentId
			: _.get(ownProps, ['match', 'params', 'invoiceDocumentId']);
		invoiceDocument = _.get(state.maps, ['invoiceDocument', invoiceDocumentId]);
	}

	/** @namespace state.maps.stationDelivery **/

	return {
		invoiceDocument,
		carrierMap : state.maps.carrier,
		resourceMap : state.maps.resource,
		terminalMap : state.maps.terminal,
		supplierMap : state.maps.supplier,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getInvoiceDocuments : get,
	addInvoiceDocument : add,
	updateInvoiceDocument : update,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
